var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "pb-0",
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [
          _c("gg-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              label: "Key Name",
              name: "Key Name",
              "error-messages": _vm.errors.collect("Key Name")
            },
            model: {
              value: _vm.keyData.name,
              callback: function callback($$v) {
                _vm.$set(_vm.keyData, "name", $$v)
              },
              expression: "keyData.name"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pb-0",
          attrs: {
            cols: "12",
            md: "6"
          }
        },
        [
          _c("gg-text-field", {
            attrs: {
              label: "Passphrase",
              type: _vm.passVisible ? "text" : "password",
              "append-icon": _vm.passVisible ? "mdi-eye-off" : "mdi-eye"
            },
            on: {
              "click:append": _vm.togglePassVisibility
            },
            model: {
              value: _vm.keyData.pass,
              callback: function callback($$v) {
                _vm.$set(_vm.keyData, "pass", $$v)
              },
              expression: "keyData.pass"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "py-0",
          attrs: {
            cols: "12"
          }
        },
        [
          _c("v-textarea", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              }
            ],
            attrs: {
              outlined: "",
              name: "Key",
              label: "Key",
              rows: "7",
              "no-resize": "",
              "error-messages": _vm.errors.collect("Key")
            },
            model: {
              value: _vm.keyData.key,
              callback: function callback($$v) {
                _vm.$set(_vm.keyData, "key", $$v)
              },
              expression: "keyData.key"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        {
          staticClass: "pt-0",
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-btn",
            {
              staticClass: "ml-0",
              attrs: {
                tile: "",
                loading: _vm.loading
              },
              on: {
                click: _vm.importKey
              }
            },
            [_vm._v(" Import Key ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }